import Hero from './components/Hero';
import Services from './components/Services';
import Process from './components/Process';
import Expertise from './components/Expertise';
import Advantages from './components/Advantages';
import CTA from './components/CTA';
import Footer from './components/Footer';
import Header from './components/Header';
import References from './components/References';
import ReferencesShowcase from './components/ReferencesShowcase';
import NewsCard from '@/components/feature/NewsCard';
import SEOHead from '@/components/feature/SEOHead';

const homeSchema = {
  "@context": "https://schema.org",
  "@type": ["GeneralContractor", "LocalBusiness", "HomeAndConstructionBusiness"],
  "@id": `${import.meta.env.VITE_SITE_URL}/#organization`,
  "name": "CasaReNovaPlus",
  "legalName": "CasaReNovaPlus Sàrl",
  "description": "Entreprise de rénovation en Suisse romande : tous types de travaux de rénovation, chauffage, ventilation, sanitaire, électricité, pompes à chaleur, domotique. Interventions à Neuenegg, Fribourg, Berne, Vaud, Valais, Neuchâtel et Jura.",
  "url": `${import.meta.env.VITE_SITE_URL}`,
  "logo": `${import.meta.env.VITE_SITE_URL}/favicon.ico`,
  "image": "https://readdy.ai/api/search-image?query=modern%20renovation%20company%20logo%20house%20tools%20minimalist%20clean%20professional%20swiss%20quality%20building%20construction&width=1200&height=630&seq=casarenovaplus-og&orientation=landscape",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Austrasse 95",
    "addressLocality": "Neuenegg",
    "addressRegion": "Fribourg",
    "postalCode": "3176",
    "addressCountry": "CH"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "46.233333",
    "longitude": "6.083333"
  },
  "email": "info@casarenovaplus.ch",
  "telephone": "+41797616282",
  "openingHoursSpecification": [
    {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday"],
      "opens": "08:00",
      "closes": "18:00"
    },
    {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": ["Saturday","Sunday"],
      "opens": "00:00",
      "closes": "23:59",
      "description": "Urgences uniquement 24/7"
    }
  ],
  "areaServed": [
    { "@type": "City", "name": "Genève" },
    { "@type": "City", "name": "Lausanne" },
    { "@type": "AdministrativeArea", "name": "Canton de Vaud" },
    { "@type": "AdministrativeArea", "name": "Canton de Fribourg" },
    { "@type": "AdministrativeArea", "name": "Canton du Valais" },
    { "@type": "AdministrativeArea", "name": "Canton de Neuchâtel" },
    { "@type": "AdministrativeArea", "name": "Canton du Jura" },
    { "@type": "AdministrativeArea", "name": "Suisse Romande" }
  ],
  "priceRange": "CHF",
  "currenciesAccepted": "CHF",
  "paymentAccepted": "Cash, Credit Card, Bank Transfer",
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Services CVSE Suisse Romande",
    "itemListElement": [
      { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Installation électrique Genève", "description": "Installations électriques conformes NIBT et OIBT à Genève et Suisse romande" } },
      { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Pompes à chaleur Suisse romande", "description": "Installation et maintenance de pompes à chaleur air-eau et géothermiques" } },
      { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Plomberie sanitaire Genève", "description": "Travaux de plomberie, sanitaire et salle de bain à Genève et Vaud" } },
      { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Ventilation climatisation Suisse romande", "description": "Systèmes de ventilation VMC et climatisation pour particuliers et entreprises" } },
      { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Domotique maison connectée Genève", "description": "Solutions domotiques et maison connectée à Genève et en Suisse romande" } },
      { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Maintenance urgence 24/7 Suisse romande", "description": "Service de maintenance et dépannage d'urgence 24h/24 en Suisse romande" } }
    ]
  }
};

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="CasaReNovaPlus Neuenegg | Rénovation Tous Travaux Suisse Romande 24/7"
        description="CasaReNovaPlus Neuenegg : tous types de travaux de rénovation, électricité, sanitaire, chauffage, ventilation et maintenance urgence 24/7. Devis gratuit sous 24h. Intervention rapide Fribourg, Berne, Vaud."
        keywords="rénovation Neuenegg, travaux rénovation Fribourg, CasaReNovaPlus, électricien Neuenegg, plombier Fribourg, chauffagiste Suisse romande, rénovation maison Berne"
        canonical={`${import.meta.env.VITE_SITE_URL}/`}
        schema={homeSchema}
      />
      <Header />
      <Hero />
      <NewsCard />
      <Services />
      <ReferencesShowcase />
      <References />
      <Advantages />
      <Expertise />
      <Process />
      <CTA />
      <Footer />
    </div>
  );
}
